import api from "@/lib/api";
import { toast } from "sonner";
import { obterBlob } from "@/components/BotaoArquivo";

const erroDoc = (e) => toast.error(e?.response?.status === 404 ? "Arquivo indisponível. Solicite um novo envio ao cliente." : "Erro ao acessar o documento");

const nomeDoHeader = (resp, d) => {
  const m = /filename="?([^";]+)"?/.exec(resp.headers?.["content-disposition"] || "");
  return m ? m[1] : `${(d.tipo || "documento").replace(/\W+/g, "-")}-${(d.id || "").slice(0, 8)}`;
};

/** Versões "com etapa" (lançam erro para o BotaoArquivo tratar). */
export const abrirDocumento = async (d, aoBaixar) => {
  const resp = await obterBlob(api, `/documents/${d.id}/arquivo`, undefined, aoBaixar);
  window.open(URL.createObjectURL(resp.data), "_blank", "noopener");
};

export const salvarDocumento = async (d, aoBaixar) => {
  const resp = await obterBlob(api, `/documents/${d.id}/arquivo`, { baixar: 1 }, aoBaixar);
  const url = URL.createObjectURL(resp.data);
  const a = document.createElement("a"); a.href = url; a.download = nomeDoHeader(resp, d); document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
};

export const abrirBlob = async (url, nome, aoBaixar, baixar = false) => {
  const resp = await obterBlob(api, url, undefined, aoBaixar);
  const blob = new Blob([resp.data], { type: resp.headers?.["content-type"] || "application/pdf" });
  const u = URL.createObjectURL(blob);
  if (baixar) { const a = document.createElement("a"); a.href = u; a.download = nome; document.body.appendChild(a); a.click(); a.remove(); }
  else window.open(u, "_blank", "noopener");
  setTimeout(() => URL.revokeObjectURL(u), 10000);
};

/** Compatibilidade: chamadas antigas com toast próprio. */
export const verDocumento = async (d) => { try { await abrirDocumento(d); } catch (e) { erroDoc(e); } };
export const baixarDocumento = async (d) => { try { await salvarDocumento(d); } catch (e) { erroDoc(e); } };
